import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  unapprovedOvertimeMinutes: number
  discardedOrAddedMinutes: number
}

const Breakdown = ({ unapprovedOvertimeMinutes, discardedOrAddedMinutes }: Props) => {
  return (
    <Box width="full" gap="s4" paddingLeft="s24">
      {unapprovedOvertimeMinutes > 0 && (
        <Item
          title={i18n.t('clock_in.sidepanel.clocked.unapproved_overtime')}
          value={unapprovedOvertimeMinutes}
        />
      )}
      {discardedOrAddedMinutes !== 0 && (
        <Item
          title={
            discardedOrAddedMinutes < 0
              ? i18n.t('clock_in.sidepanel.clocked.discarded_clocked_time') // If discardedOrAddedMinutes is negative, it means time was discarded
              : i18n.t('clock_in.sidepanel.clocked.added_clocked_time') // If discardedOrAddedMinutes is positive, it means time was added
          }
          value={Math.abs(discardedOrAddedMinutes)}
        />
      )}
    </Box>
  )
}

export default Breakdown
